import { useField } from "formik";
import React, { FC } from "react";
import style from "./style.module.scss";

interface ITextArea {
  label?: string;
  name: string;
  type: string;
  placeholder?: string;
}
export const TextArea: FC<ITextArea> = ({ label, name, type, placeholder }) => {
  const [field] = useField({
    name,
    type,
  });
  return (
    <div className={style.wrapper}>
      {label ? <label className={style.labelText}>{label}</label> : null}
      <textarea
        placeholder={placeholder}
        value={field.value}
        onChange={field.onChange}
        name={field.name}
        className={style.textArea}
      />
    </div>
  );
};
